import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_ProductAttributeGroupRelationshipRow,
    WB_ProductAttributeGroupRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbProductAttributeGroup} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Product_Attribute_Group,
    esWB_Product_Attribute_Group_Relationship,
    esWB_Subject_Area
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class ProductAttributeGroupBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_ProductAttributeGroup: WB_ProductAttributeGroupRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Set'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_ProductAttributeGroup = null;
    }

    get WB_ProductAttributeGroup(): WB_ProductAttributeGroupRow
    {
        return this.drWB_ProductAttributeGroup;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating Product Attribute Group");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                let sError = "Unable to determine dbContext for new ProductAttributeGroup.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Product_Attribute_Group)
                .then((newProductAttributeGroupRow: WB_ProductAttributeGroupRow)=> {
                    newProductAttributeGroupRow.setDefaults();
                    self.drWB_ProductAttributeGroup = newProductAttributeGroupRow;
                    self.dbContext.add(esWB_Product_Attribute_Group, newProductAttributeGroupRow);
                    self.Identity.setAll(self.WB_ProductAttributeGroup.cif.WB_PRDATTRGRP_ID, self.WB_ProductAttributeGroup.cif.ATTRIB_GROUP_ID, self.WB_ProductAttributeGroup.cif.ATTRIB_GROUP_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_ProductAttributeGroup, 'WB_PRDATTRGRP_ID','ATTRIB_GROUP_ID','ATTRIB_GROUP_NAME');

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                let sError = "Product Attribute Group already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if(self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for Product Attribute Group.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any> self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = ProductAttributeGroupBO.createRecordResolver({dbContext: self.dbContext});
                recordResolverLoadPromise = ProductAttributeGroupBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let newProductAttributeGroupRow: any = recordResolver.get(esWB_Product_Attribute_Group, anId);

                    if(_.isEmpty(newProductAttributeGroupRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_ProductAttributeGroup = newProductAttributeGroupRow;
                    self.Identity.setAll(self.WB_ProductAttributeGroup.cif.WB_PRDATTRGRP_ID, self.WB_ProductAttributeGroup.cif.ATTRIB_GROUP_ID, self.WB_ProductAttributeGroup.cif.ATTRIB_GROUP_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_ProductAttributeGroup, 'WB_PRDATTRGRP_ID','ATTRIB_GROUP_ID','ATTRIB_GROUP_NAME');
                })
                .then((newProductAttributeGroupRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err:any)=>{
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_ProductAttributeGroup.cif.ATTRIB_GROUP_NAME + "(" + self.WB_ProductAttributeGroup.cif.ATTRIB_GROUP_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate ProductAttributeGroup.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbProductAttributeGroup = <IwbProductAttributeGroup>self.drWB_ProductAttributeGroup;
        this.SaveProgressProvider.start("Saving " + wbProductAttributeGroup.ATTRIB_GROUP_NAME + "(" + wbProductAttributeGroup.ATTRIB_GROUP_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save ProductAttributeGroup.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            saveFunction(esWB_Product_Attribute_Group, self.drWB_ProductAttributeGroup,{})
                .then((ignored) => {
                    let tasks: Promise<any>[] = [];
                    tasks.push(saveFunction(esWB_Product_Attribute_Group_Relationship, self.drWB_ProductAttributeGroup.WB_ProductAttributeGroupRelationshipRows));

                    return Promise.all(tasks);
                })
                .then((ignored)=>{
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }


    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        let self = this;
        let wbProductAttributeGroup = <IwbProductAttributeGroup>self.drWB_ProductAttributeGroup;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbProductAttributeGroup.ATTRIB_GROUP_NAME + "(" + wbProductAttributeGroup.ATTRIB_GROUP_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Customer

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ProductAttributeGroup.markDeleted();

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    addAttribute(): Promise<IBusinessObject> {
        const self = this;
        return new Promise<IBusinessObject>((resolve, reject)=> {

            self.dbContext.createRecordWithKey(esWB_Product_Attribute_Group_Relationship)
                .then((aPrdAttrGrpRelRow: WB_ProductAttributeGroupRelationshipRow)=>{
                    aPrdAttrGrpRelRow.setDefaults();
                    aPrdAttrGrpRelRow.cif.WB_PRDATTRGRP_ID = self.drWB_ProductAttributeGroup.cif.WB_PRDATTRGRP_ID;
                    aPrdAttrGrpRelRow.WB_ProductAttributeGroupRow = self.drWB_ProductAttributeGroup;
                    self.dbContext.add(esWB_Product_Attribute_Group_Relationship, aPrdAttrGrpRelRow);
                    resolve(self)
                })
                .catch((err)=>{
                    reject(err)
                })
        })

    }

    removeAttribute(aWB_ProductAttributeGroupR_ID: number): Promise<IBusinessObject>{
        const self = this;

        return new Promise<IBusinessObject>((resolve, reject)=>{
            _.forEach(self.drWB_ProductAttributeGroup.WB_ProductAttributeGroupRelationshipRows, (aPrdAttributeGroupR: WB_ProductAttributeGroupRelationshipRow)=>{
                if(aPrdAttributeGroupR.isActive && aPrdAttributeGroupR.cif.WB_PRDATTRGRPR_ID == aWB_ProductAttributeGroupR_ID){
                    aPrdAttributeGroupR.markDeleted();
                }
            });
            resolve(self)
        })
    }

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const product_attribute_group_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        };

        const aRecResolver = new ESRecordResolver(dbContext, product_attribute_group_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Product_Attribute_Group,ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

}
PAEnvironment.registerBusinessObjectClass( ProductAttributeGroupBO, "ProductAttributeGroupBO", "Product Attribute Group")